import React from "react";
import { Card } from "react-bootstrap";
import "./style.css";

function PortfolioCard(props) {
  return (
    <div>
    <Card style={{ width: "20rem" }}>
      <Card.Img variant="top" src={props.image} />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text>{props.description}</Card.Text>
      </Card.Body>
      <Card.Body>
        {/* <a href={props.ghLink}>
        <AiFillGithub/>
        </a>
        <a href={props.ghLink}>
        <AiFillGithub href={props.liveLink}/>
        </a> */}
      </Card.Body>
    </Card>
    </div>
  );
}

export default PortfolioCard;

